module.exports = __webpack_public_path__ + "static/media/Vertical-Layout.c8c355b5.png";